/* MARMOT каталог — чиста логика за началния възрастов диапазон (без DOM).

   Изнесена отделно за `node --test`. В браузъра се закача на
   window.MarmotCatalogLogic, а в Node се експортва през module.exports. */
(function (root, factory) {
  var api = factory();
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  else root.MarmotCatalogLogic = api;
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  function clampAge(value) {
    return Math.min(Math.max(value, 1), 11);
  }

  /* Разпознава само точния кирилски handle „N-години". String(number)
     е обратната проверка, която отхвърля нецифри и варианти като „05". */
  function ageStartFromHandle(handle) {
    var text = typeof handle === 'string' ? handle : '';
    var suffix = '-години';
    var suffixAt = text.indexOf(suffix);
    if (suffixAt === -1) return null;

    var base = text.slice(0, suffixAt);
    var full = base + suffix;
    var number = parseInt(base, 10);
    if (full !== text || !(number > 0) || String(number) !== base) return null;
    return clampAge(number);
  }

  function paramValue(params, name) {
    if (!params) return null;
    if (typeof params.get === 'function') return params.get(name);
    return Object.prototype.hasOwnProperty.call(params, name) ? params[name] : null;
  }

  /* URL диапазонът е с предимство пред пресета на колекцията. При липса
     на URL: възрастова колекция започва от N до 11, каталогът — от 1 до 11. */
  function resolveInitialRange(presetAge, params) {
    var preset = parseInt(presetAge, 10);
    var aMin = !isNaN(preset) && preset > 0 ? clampAge(preset) : 1;
    var aMax = 11;
    var urlMin = parseInt(paramValue(params, 'age_min'), 10);
    var urlMax = parseInt(paramValue(params, 'age_max'), 10);
    var fromURL = !isNaN(urlMin) || !isNaN(urlMax);

    if (fromURL) {
      if (isNaN(urlMin)) urlMin = 1;
      if (isNaN(urlMax)) urlMax = 11;
      aMin = clampAge(urlMin);
      aMax = clampAge(urlMax);
      if (aMin > aMax) {
        var swap = aMin;
        aMin = aMax;
        aMax = swap;
      }
    }

    return { aMin: aMin, aMax: aMax, fromURL: fromURL };
  }

  /* Има ли какво да чисти бутонът „Изчисти филтрите": търсене, избран пил
     или диапазон, различен от НАЧАЛНИЯ за страницата. Възрастовата колекция
     се отваря с активен слайдер, но с празно за чистене състояние – затова
     сравняваме с началния диапазон, а не с целия 1–11. */
  function hasClearableState(current, initial) {
    var now = current || {};
    var base = initial || { aMin: 1, aMax: 11 };
    if (now.q && String(now.q).trim()) return true;
    if (now.age || now.type) return true;
    return now.aMin !== base.aMin || now.aMax !== base.aMax;
  }

  return {
    ageStartFromHandle: ageStartFromHandle,
    resolveInitialRange: resolveInitialRange,
    hasClearableState: hasClearableState
  };
});
